import React from "react";
import styled from "styled-components";
import NuestroProceso from "./NuestroProceso";
import Contact from "./Contact";

// Elegant & Luxury Color Palette
const primaryColor = "#0a0f2c"; // Deep Navy Blue
const accentColor = "#d4af37"; // Elegant Gold
const backgroundColor = "#fdfcf9"; // Warm white
const textColor = "#1a1a1a"; // Refined dark grey
const cardColor = "#ffffff";

const Container = styled.div`
  background: ${backgroundColor};
  color: ${textColor};
  padding: 80px 20px;
  font-family: 'Georgia', serif;
`;

const Content = styled.div`
  max-width: 1100px;
  margin: auto;
  padding: 60px;
  background: ${cardColor};
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  border: 1px solid #eaeaea;
`;

const Title = styled.h2`
  font-size: 2.8rem;
  text-align: center;
  color: ${primaryColor};
  font-weight: 700;
  font-family: 'Playfair Display', serif;
  margin-bottom: 40px;
  letter-spacing: 1px;
`;

const Subtitle = styled.h3`
  font-size: 1.6rem;
  color: ${accentColor};
  font-weight: 600;
  margin-bottom: 25px;
  text-align: center;
`;

const Description = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  color: ${textColor};
  max-width: 850px;
  margin: 0 auto 20px auto;
  font-family: 'Georgia', serif;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 30px 0;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  padding: 12px 0;
  display: flex;
  align-items: center;
  font-weight: 500;
  border-bottom: 1px solid #ddd;
  &:before {
    content: "✔";
    color: ${accentColor};
    font-weight: bold;
    margin-right: 15px;
  }
`;

const Step = styled.div`
  background: #f3f3f3;
  padding: 20px 25px;
  border-left: 6px solid ${accentColor};
  font-size: 1.1rem;
  font-style: italic;
  font-family: 'Georgia', serif;
  margin-bottom: 30px;
`;

const ContactInfo = styled.div`
  margin-top: 50px;
  font-size: 1.1rem;
  background: #fcfcfc;
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  box-shadow: 0 0 10px rgba(0,0,0,0.03);
`;

const Highlight = styled.span`
  color: ${accentColor};
  font-weight: bold;
`;

const Button = styled.a`
  display: inline-block;
  margin-top: 30px;
  padding: 14px 30px;
  font-size: 1.15rem;
  color: white;
  background: ${primaryColor};
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.3s ease;
  &:hover {
    background: ${accentColor};
    color: ${primaryColor};
  }
`;

function Home() {
  return (
    <Container>
      <Content>
        <Title>Soma Mediación – Resolviendo Conflictos de Forma Pacífica y Efectiva</Title>
        <br/>


        <Subtitle>La Solución Inteligente para Evitar Juicios Prolongados</Subtitle>
        <Description>
          En <Highlight>Soma Mediación</Highlight>, creemos en el poder del diálogo para resolver conflictos de manera justa, rápida y sin los altos costos de un litigio. A través de nuestros servicios de mediación, ayudamos a individuos, familias, comunidades y empresas a encontrar soluciones efectivas y personalizadas en la Ciudad de México y todo México.
        </Description>
        <br/>
        
        <Subtitle>¿Quiénes Somos?</Subtitle>
        <Description>
          En <Highlight>Soma</Highlight>, nos especializamos en la resolución de
          conflictos a través de la mediación y la negociación, ofreciendo
          soluciones rápidas, accesibles y efectivas para evitar largos procesos
          judiciales.
        </Description>
        <br/>

        <Subtitle>Nuestros Servicios</Subtitle>
        <List>
          <ListItem>Mediación Familiar</ListItem>
          <ListItem>Mediación Civil y Mercantil</ListItem>
          <ListItem> Mediación Empresarial y Laboral</ListItem>
          <ListItem>Mediación Laboral</ListItem>
          <ListItem>Mediación Comunitaria y Vecinal</ListItem>
        </List>

        <Subtitle>¿Por Qué Elegirnos?</Subtitle>
        <List>
          <ListItem>Proceso Confidencial y Eficiente</ListItem>
          <ListItem>Ahorro de Costos</ListItem>
          <ListItem>Atención Personalizada</ListItem>
          <ListItem>Profesionales Expertos</ListItem>
          <ListItem>Resoluciones Rápidas</ListItem>
          <ListItem>Expertos Certificados </ListItem>
        </List>

        <Subtitle>Ubicación y Contacto</Subtitle>
        <ContactInfo>
          <Contact />
        </ContactInfo>
      </Content>
    </Container>
  );
}

export default Home;
